import { AutoCompleteValue } from 'shared/autocomplete/AutoComplete';

export function getInputValue<TData>(
    item: AutoCompleteValue<TData> | undefined,
    renderItem: (item: TData) => string,
) {
    if (item === null || item === undefined) {
        return '';
    }

    if (typeof item === 'string') {
        return item;
    }

    return renderItem(item);
}
